import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
// import Productview from "@/views/productservice/productview.vue";
import Productview from "@/views/newhome/product.vue";

// import Aboutusview from "@/views/aboutus/aboutusview.vue";
import Aboutusview from "@/views/newhome/aboutuspage.vue";

// import serviceprocess from "@/views/homeview/serviceprocess/serviceprocessview.vue";
import serviceprocess from "@/views/newhome/securityAudit.vue";

// import DataAssetview from "@/views/homeview/dataAssetview.vue";
import Technical from "@/views/newhome/technical.vue";
import DataAssetview from "@/views/newhome/dataasset.vue";
import Onchainatm from "@/views/newhome/onchainatm.vue";

import serviceadvantages from "@/views/homeview/serviceadvantages/serviceadvantagesview.vue";
import moneyinvolved from "@/views/newhome/moneyinvolved.vue";
import introduceview from "@/views/newhome/businessintroduce.vue";

import Serviceview from "@/views/homeview/serviceadvantage/serviceview.vue";
import Security from "@/views/homeview/graphchainsecurity/security.vue";

const routes = [
  {
    //没写就是任意路由都是定向这个
    path: "",
    //重定向
    redirect: "/home",
  },

  {
    path: "/home",
    name: "home",
    component: HomeView,
  },
  {
    path: "/product",
    name: "product",
    component: Productview,
    // component: introduceview,
  },
  {
    path: "/aboutus",
    name: "aboutus",
    component: Aboutusview,
  },
  {
    path: "/technical",
    name: "technical",
    component: Technical,
  },
  {
    path: "/security",
    name: "security",
    component: Security,
  },
  {
    path: "/businessintroduce",
    name: "businessintroduce",
    component: introduceview,
  },
  {
    path: "/moneyinvolved",
    name: "moneyinvolved",
    component: moneyinvolved,
  },
  {
    path: "/onchainatm",
    name: "onchainatm",
    component: Onchainatm,
  },
  {
    path: "/serviceprocess",
    name: "serviceprocess",
    component: serviceprocess,
  },
  {
    path: "/serviceadvantages",
    name: "serviceadvantages",
    component: serviceadvantages,
  },
  { path: "/dataasset", name: "dataasset", component: DataAssetview },

  {
    path: "/serviceadvantage",
    name: "serviceadvantage",
    component: Serviceview,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
router.afterEach(() => {
  window.scrollTo(0, 0);
});
